/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1ExamRevisionLangBotexamlangidFinishTranslationMutationResponse,
  PostApiV1ExamRevisionLangBotexamlangidFinishTranslationPathParams,
  PostApiV1ExamRevisionLangBotexamlangidFinishTranslation400,
  PostApiV1ExamRevisionLangBotexamlangidFinishTranslation401,
  PostApiV1ExamRevisionLangBotexamlangidFinishTranslation404,
  PostApiV1ExamRevisionLangBotexamlangidFinishTranslation500,
} from "../../types/examRevisionController/PostApiV1ExamRevisionLangBotexamlangidFinishTranslation.ts";

function getPostApiV1ExamRevisionLangBotexamlangidFinishTranslationUrl(
  botExamLangId: PostApiV1ExamRevisionLangBotexamlangidFinishTranslationPathParams["botExamLangId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/exam/revision/lang/${botExamLangId}/finish-translation` as const,
  };
  return res;
}

/**
 * @description Marca todas as questões do idioma informado como Revisadas, atualiza o status do idioma para Reviewed e recalcula o status geral da prova: se todos os idiomas estiverem Reviewed o BotExam passa para Reviewed, caso contrário permanece em PendingTranslation. **(Requer Authorization para autenticação)**
 * @summary Finalizar tradução de idioma de prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/lang/:botExamLangId/finish-translation}
 */
export async function postApiV1ExamRevisionLangBotexamlangidFinishTranslation(
  botExamLangId: PostApiV1ExamRevisionLangBotexamlangidFinishTranslationPathParams["botExamLangId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiV1ExamRevisionLangBotexamlangidFinishTranslationMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation400
      | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation401
      | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation404
      | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation500
    >,
    unknown
  >({
    method: "POST",
    url: getPostApiV1ExamRevisionLangBotexamlangidFinishTranslationUrl(
      botExamLangId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
